<script lang="ts" module>
  const iconMap = new Map([
    ['online', faCircleCheck],
    ['offline', faCircleXmark],
  ]);

  const colorMap = new Map([
    ['online', 'text-green-600'],
    ['offline', 'text-gray-500'],
  ]);
</script>

<script lang="ts">
  import Fa from 'svelte-fa';
  import {
    faCircleCheck,
    faCircleQuestion,
    faCircleXmark,
  } from '@fortawesome/free-solid-svg-icons';

  interface Props {
    status: { status: 'online' | 'offline' };
  }

  let { status }: Props = $props();

  let icon = $derived(iconMap.get(status.status) ?? faCircleQuestion);
</script>

<span class={['inline-block', colorMap.get(status.status)]}>
  <Fa {icon} />
</span>
